//componente per la scelta del tipo di file per l'aggiunta layer da file
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {changeTypeLayer} from '../redux'
import { connect } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(0),
    minWidth: 100,
  },
  selectEmpty: {
    marginTop: theme.spacing(0),
  },
}));

 function ChooseFile(props) {
    
  const classes = useStyles();
  const [status, setStatus] = React.useState('');

  const handleChange = (event) => {
    
    setStatus(event.target.value);
    
     props.changeTypeLayer({type:event.target.value})
  };
  return (
        <FormControl className={classes.formControl}>
        <Select
        
          value={status}
          onChange={handleChange}
          displayEmpty
          className={classes.selectEmpty}
          inputProps={{ 'aria-label': 'Without label' }}
          
        >
          <MenuItem value={'ShapeFile'}>ShapeFile</MenuItem>
          <MenuItem value={'KML'}>KML</MenuItem>
          <MenuItem value={'KMZ'}>KMZ</MenuItem>
          <MenuItem value={'GeoJSON'}>GeoJSON</MenuItem>
          <MenuItem value={'CSV'}>CSV</MenuItem>
        </Select>
      </FormControl>
   )}
   const mapStateToProps = state => {
    return {
      typeLayer: state.typeLayer
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
      changeTypeLayer: (typeLayer) => dispatch(changeTypeLayer(typeLayer))
    }
  }
  export default connect(mapStateToProps,mapDispatchToProps)(ChooseFile)